export default function NoMessagesToShowInfoText() {
  return (
    <div className="text-gray">
      <p className="m-2">Inga meddelanden.</p>
      <p className="m-2">
        Skapa ett nytt meddelande genom att klicka på Ny konversation (+).
      </p>
    </div>
  );
}
